module.exports = __webpack_public_path__ + "img/cszq_logo.189ff1e6.png";